import { toLowerCamelCase } from './string.helpers'

function mergeToNewObject(obj1, ...rest) {
  const newObject = rest.reduce((curr, next) => {
    return Object.assign({}, curr, next)
  }, {})

  return Object.assign({}, obj1, newObject)
}

const isObject = (obj) => {
  return obj === Object(obj) && !isArray(obj) && typeof obj !== 'function'
}

const isArray = (arr) => {
  return Array.isArray(arr)
}

const keysToCamel = (obj) => {
  if (isObject(obj)) {
    const n = {}
    Object.keys(obj).forEach((k) => {
      n[toLowerCamelCase(k)] = keysToCamel(obj[k])
    })
    return n
  } else if (isArray(obj)) {
    return obj.map((i) => {
      return keysToCamel(i)
    })
  }
  return obj
}

const containsNoValues = (values) => {
  return !Object.values(values).some((value) => value)
}

const mergeUniqueList = (arr1, arr2, key) => {
  const map = new Map()

  arr1.forEach((item) => map.set(item[key], item))

  arr2.forEach((item) => map.set(item[key], item))

  return Array.from(map.values())
}

export { mergeToNewObject, keysToCamel, containsNoValues, mergeUniqueList }
